// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const fa: ChromeTranslations = {
  'nav.nextPage': '← صفحهٔ بعد',
  'nav.previousPage': 'صفحهٔ قبل →',
  'nav.continueToLevel': '← ادامه به مرحله',
  'nav.backToMenu': '← بازگشت به منو',
  'howto.page': 'صفحهٔ {n} از {total}',
  'options.title': 'تنظیمات',
  'ui.language': 'زبان',
};
